export default __webpack_public_path__ + "static/media/Marcin Sidorowicz.92104436.webp";